import AttributeGroup from "@/api/Product/AttributeGroup";

export class ProductDTO {
    id?: number;
    name = "";
    shortName = "";
    sku = "";
    image = "";
    url = "";
    price = 0;
    specialPrice = 0;
    stockStatus = 1;
    attributeGroups?: AttributeGroup[];
}

export default class Product extends ProductDTO {
    constructor(dto?: ProductDTO) {
        super();
        if(dto) {
            Object.assign(this, dto);
        }
    }
}